export default function clientConfig() {
  const config = {
    codCliente: 1000, // 9156 - HMG || 2156 - PRD
    plano: 2, //
    tipo: 2, //
  }

  return config
}
